import { or, Roles } from '@/js/libs/use-auth';

// ws-ssp-data-delivery serves the Adomik seats, and the toggle that switches a seat on or off, to
// ADMIN and COMPANY_ADMIN only (Security.isCompanyAdmin), so the seats route and the Seats tab
// open to that audience and to no one else.
export const ADOMIK_SEATS_ROLES = or(Roles.ADMIN, Roles.COMPANY_ADMIN);
